import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Link } from '@router/Link';
import { useAtomValue } from 'jotai';

import styles from './styles.module.scss';
import { currentCardAtom } from '../../atoms/prepaidCardAtoms';

function CardDetail() {
  const card = useAtomValue(currentCardAtom);
  return (
        <Column className={styles.container}
                fullWidth
                as='section'
                spacing={12}
                align='center' >
            <Text color={colors.gray7}
                  fontWeight='bold'
                  size='2xl' >
                {card?.name}
            </Text>
            <Row spacing={8}>
                <Text size='xl' fontWeight='bold' color={colors.gray6}>
                    잔액
                </Text>
                <Row>
                    <Text size='3xl' fontWeight='bold' color={colors.gray8}>
                        {card?.balance.toLocaleString()}
                    </Text>
                    <Text size='xl' fontWeight='bold' color={colors.gray6}>
                        원
                    </Text>
                </Row>
                {card && (
                    <Link activityParams={{ prepaidCardId: card.id }}
                          activityName='PrepaidCardChargeActivity' >
                        <button className={styles.charge}>
                            충전
                        </button>
                    </Link>
                )}

            </Row>
            <Column className={styles.barcode}
                    spacing={4}
                    align='center' >
                <CustomBarcode value={card?.barcodeNo || ''}/>
                <Text>
                    {card?.barcodeNo}
                </Text>
            </Column>
        </Column>
  );
}

export default CardDetail;
